import FacebookPixelSettings from './FacebookPixelSettings';

export default FacebookPixelSettings;
